import React, { useEffect, useRef, useState } from "react";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import Select from "../../Common/FormElements/Select/Select";
import Separator from "../../Common/Separator/Separator";
import { profileForm, updateProfileForm } from "./data";
import PassswordInput from "../../Common/Forms/ResetPassword/PassswordInput";
import userPhoto from "../../../Images/Images/avatar.png";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";

function Informations({
  isUpdating,
  formData,
  setFormData,
  setDisabled,
  customErrors,
  setCustomErrors,
  setDeletedPhotoId,
}) {
  const fileInputRef = useRef(null);
  const { t } = useTranslation("common");
  const [invalidFields, setInvalidFields] = useState([]);
  const { user } = useSelector((state) => state.userReducer);

  let photo = userPhoto;
  if (formData.photo instanceof File) {
    photo = URL.createObjectURL(formData.photo);
  } else if (formData.photo) {
    photo = `${IMAGE_END_POINT}${formData?.photo?.attributes?.url}`;
  }

  const currForm = isUpdating ? updateProfileForm : profileForm;
  const errorsMap = {
    exist: t("This email is already in use."),
    phoneNumberError: t("Please enter a valid phone number."),
    emailError: t("Please enter a valid email."),
  };
  const checkeFormValidation = () => {
    const updatedInvalidFields = [];
    currForm.forEach(({ name, type, required }) => {
      if (required) {
        if (type === "select") {
          if (
            formData[name]?.code === undefined ||
            formData[name]?.code === null
          ) {
            updatedInvalidFields.push(name);
          }
        } else if (name === "password") {
          if (isUpdating) {
            if (
              formData?.password?.length > 0 &&
              formData?.password?.length < 6
            ) {
              updatedInvalidFields.push(name);
            }
          } else if (formData?.password?.length < 6) {
            updatedInvalidFields.push(name);
          }
        } else if (
          formData[name] === undefined ||
          formData[name] === null ||
          !String(formData[name])?.trim()?.length > 0
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });
    if (updatedInvalidFields?.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    setInvalidFields(updatedInvalidFields);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (customErrors && customErrors[name]) {
      setCustomErrors((state) => {
        const updatedState = state;
        if (updatedState[name]) {
          delete updatedState[name];
        }
        return updatedState;
      });
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      if (formData?.photo?.id) {
        setDeletedPhotoId(formData?.photo?.id);
      }

      setFormData((prev) => {
        let updatedFormData = { ...prev };
        updatedFormData = {
          ...updatedFormData,
          photo: imageFile,
        };
        return updatedFormData;
      });
    }
  };

  useEffect(() => {
    checkeFormValidation();
  }, [formData]);

  return (
    <div className="modalContent px-5 pt-4">
      <Row>
        <Col lg={3}>
          <div className="d-flex justify-content-center align-self-lg-start position-relative pointer">
            <label htmlFor="imageInput" className="imageInput">
              <img
                src={photo}
                alt="Revendeur"
                className="br50 ob-cover w100 h100 pointer"
                onClick={handleClick}
              />
            </label>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
            <div className="iconContainer ms-n3 d-flex align-items-center justify-content-center bg-softBlue br50 size-40px mt-auto">
              <i
                className="bi bi-camera text-white f18"
                onClick={handleClick}
              />
            </div>
          </div>
        </Col>

        <Col>
          <Row>
            {currForm.map((el) => {
              if (el?.type === "select") {
                return (
                  <Col lg={el?.span ?? 6} key={el.name} className="mb-4">
                    <p className="f16 text-ultraBlack mb-2">
                      {t(`${el.label ?? 3}`)}
                    </p>
                    <Select
                      {...el}
                      placeholder={t(`${el.placeholder ?? ""}`)}
                      value={formData[el.name]}
                      callback={handleChange}
                    />
                  </Col>
                );
              }

              return (
                <Col
                  lg={el?.span ?? 6}
                  key={el.name}
                  className={`${
                    customErrors && customErrors[el?.name] ? "mb-2" : "mb-4"
                  }`}
                >
                  {el?.separator && (
                    <div className="mb-3">
                      <Separator />
                    </div>
                  )}
                  <p className="f16 text-ultraBlack mb-2">
                    {t(`${el.label ?? ""}`)}
                  </p>
                  {el?.type !== "password" ? (
                    <TextInput
                      {...el}
                      placeholder={t(`${el.placeholder ?? ""}`)}
                      value={formData[el?.name]}
                      callback={handleChange}
                    />
                  ) : (
                    ((isUpdating && user?.attributes?.userRole === 1) ||
                      !isUpdating) && (
                      <>
                        <Separator className="my-3" />
                        <PassswordInput
                          {...el}
                          value={formData[el?.name]}
                          callback={handleChange}
                          text={t("Password")}
                        />
                      </>
                    )
                  )}
                  {customErrors &&
                    errorsMap.hasOwnProperty(customErrors[el?.name]) && (
                      <div className="mt-2 text-redCalendar f14">
                        {errorsMap[customErrors[el?.name]]}
                      </div>
                    )}
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default Informations;
